/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Named so the generator emits the shared `TitleTypeEnum` rather than a second inlined copy — the search DTO\'s `titleTypes` filter is typed from the same enum, and two nominal copies of the same 8 members cannot be compared.
 * @export
 * @enum {string}
 */
export const TitleTypeEnum = {
    Documentary: 'documentary',
    FeatureDoc: 'feature-doc',
    FeatureFilm: 'feature-film',
    Serial: 'serial',
    SeriesFactual: 'series-factual',
    SeriesFictional: 'series-fictional',
    ShortFilm: 'short-film',
    Telefilm: 'telefilm',
};
